import { Query } from "@datorama/akita";
import { injectable } from "tsyringe";

import InstagramTaggedProductStore, {
    TaggedProductState,
} from "../stores/InstagramTaggedProductStore";

@injectable()
class InstagramTaggedProductQuery extends Query<TaggedProductState> {
    constructor(protected store: InstagramTaggedProductStore) {
        super(store);
    }
    product$ = this.select((v) => v.product);
}

export default InstagramTaggedProductQuery;
